/** @typedef {{popular: boolean}} Props */

import { translate } from '../../App/Internationalization';
import React from 'react';

/**
 * @param {Props} props
 * @returns {JSX.Element}
 */
function PopularHeader(props) {
	if (!props?.popular) {
		return <div className="lg:h-10" />;
	}

	return (
		<h3 className="bg-theme w-fit px-2 py-1 font-medium text-ms-2 rounded text-theme-fg">
			{translate('subscription.plans.popular')}
		</h3>
	);
}

export default React.memo(PopularHeader);
